import { notification } from "antd";
import { BackbuttonComponent } from "../../../components";
import { useQuery } from "../../../hooks";
import { DevBoostFormView } from "../../admin/view/dev-boost/views/dev-boost-form.view";
import { useParams } from "react-router-dom";

export const DevBoostEdit = () => {
    const [, contextHolder] = notification.useNotification();
    const { devboostId } = useParams();
    const { data, loading } = useQuery({
        url: `/devboost/${devboostId}`,
        options: { method: "GET" },
    });
    return loading || !data ? null : (
        <>
            {contextHolder}
            <BackbuttonComponent />
            <DevBoostFormView
                mode="edit"
                initialValues={data}
            />
        </>
    );
};

export const DevBoostEditRoute = ({ devboostId }) =>
    `/dev-boost/${devboostId}/edit`;
